export class AddDataToWorkOrderRequest {
  WorkOrderID: number;
  ConveyanceID: number;
  DataName: string;
  DataValue: string;
}
